import { render } from "./Mono.vue?vue&type=template&id=e474e51e"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Mono.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e474e51e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e474e51e', __exports__)) {
    api.reload('e474e51e', __exports__)
  }
  
  module.hot.accept("./Mono.vue?vue&type=template&id=e474e51e", () => {
    api.rerender('e474e51e', render)
  })

}


export default __exports__